import React from 'react';
import PropTypes from 'prop-types';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import LinearProgress from 'material-ui/LinearProgress';
import SovosPaginationFooter from 's1-ui/sovos-pagination-footer';
import { gridHeaderColorGray } from 'theme/mainColors';
import ContextualGridMenuOptions from '../../contextualGridMenuOptions/ContextualGridMenuOptions';
import { RULE_PROP_TYPE } from 'shared/constants/PropTypes';
import './allocationGrid.scss';

const headerLabelStyle = {
  color: gridHeaderColorGray,
  fontWeight: 400,
  fontSize: 15,
  paddingBottom: 0
};

class AllocationGrid extends React.Component {
  constructor(props){
    super(props);
    this.AllocationGridColumns = [
      {
        title: 'Name',
        dataKey: 'name',
        width: 200
      },{
        title: 'Description',
        dataKey: 'description',
        width: 450
      }
    ];
    this.state = {
      hoveredRow: -1,
      itemsPerPage: 10,
      page: 0,
      allocationSelected: { id: 0 }
    };
  }

  handleRowHover = hoveredRow => this.setState({ hoveredRow });

  handleCellClick = rowID => {
    this.setState( { allocationSelected: this.props.allocationRules[rowID] });
    this.props.onAllocationSelect(this.props.allocationRules[rowID]);
  };

  getStartItem = () => (this.props.pageState.totalEntries ? ((this.state.itemsPerPage * (this.state.page)) + 1) : 0);

  calculateEndItem = () => {
    const maximumItemsOnPage = this.state.itemsPerPage * (this.state.page + 1);
    if (maximumItemsOnPage > this.props.pageState.totalEntries) {
      return this.props.pageState.totalEntries;
    }
    return maximumItemsOnPage;
  };

  handlePrevPage = ev => {
    ev.preventDefault();
    this.setState(oldState => {
      if(oldState.page > 0 ) {
        this.props.onPageChange(oldState.page - 1, oldState.itemsPerPage);
        return ({
          page: oldState.page - 1
        });
      }
      else {
        return ({});
      }
    });
  };

  handleNextPage = ev => {
    ev.preventDefault();
    this.setState(oldState => {
      if((oldState.page + 1) * oldState.itemsPerPage < this.props.pageState.totalEntries) {
        this.props.onPageChange(oldState.page + 1, oldState.itemsPerPage);
        return ({
          page: oldState.page + 1
        });
      }
      else {
        return ({});
      }
    });
  };

  handlePerPageChanged = ev => {
    const pageSize = ev.target.value;
    this.setState({ page: 0, itemsPerPage: pageSize });
    this.props.onPageChange(0, pageSize);
  };

  render() {
    const { backgroundColor, fetchingAllocations, allocationRules, pageState } = this.props;

    return (
      <div className="allocation-grid__main-container">
        {
          fetchingAllocations &&
          <div className="allocation-grid__over-layer">
            <LinearProgress mode="indeterminate" />
          </div>
        }
        <div className={ `allocation-grid__table-container${ fetchingAllocations ? ' blur-content' : '' }` }>
          {
            allocationRules.length > 0 &&
            <Table
              key="AllocationGrid"
              fixedHeader={ true }
              onRowHover={ this.handleRowHover }
              onCellClick={ this.handleCellClick }
              multiSelectable={ false }
              className="allocation-grid"
              style={ { backgroundColor: backgroundColor } }
            >
              <TableHeader displaySelectAll={ false } enableSelectAll={ false } adjustForCheckbox={ false } style={ { border: 'none' } }>
                <TableRow style={ { border: 'none' } }>
                  { this.AllocationGridColumns.map(({ dataKey, width, title, disabled }) => (
                    !disabled && <TableHeaderColumn key={ dataKey } style={ { width: width || 'auto', ...headerLabelStyle } }>
                      { title }
                    </TableHeaderColumn>
                  ))}
                </TableRow>
              </TableHeader>
              <TableBody showRowHover={ true } displayRowCheckbox={ false } deselectOnClickaway={ false }>
                { allocationRules.map((allocation, index) => (
                  <TableRow
                    id={ `import-allocation-grid-row-${index}` }
                    key={ index }
                    selected={ allocation.id === this.state.allocationSelected.id }
                    className={ `allocation-grid__table-row` }
                  >
                    { this.AllocationGridColumns.map(({dataKey, width, disabled}) => (
                      !disabled && <TableRowColumn key={ dataKey } style={ {width: width || 'auto', textOverflow: `${dataKey !== 'moreOptions' ? 'ellipsis' : 'unset'}`} }>{
                        (dataKey !== 'moreOptions') ?
                          allocation[dataKey] :
                          this.state.hoveredRow === index && <ContextualGridMenuOptions editDisabled={ false } deleteDisabled={ false } elementId={ allocation.id } />
                      }</TableRowColumn>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          }
          {
            allocationRules.length > 0 &&
            <SovosPaginationFooter
              key="AllocationPaginationFooter"
              endItem={ this.calculateEndItem() }
              itemsPerPage={ this.state.itemsPerPage }
              startItem={ this.getStartItem() }
              totalItems={ pageState.totalEntries }
              onPrevClicked={ this.handlePrevPage }
              onNextClicked={ this.handleNextPage }
              onPerPageChanged={ this.handlePerPageChanged }
              itemsPerPageOptions={ [ 10, 25, 50 ] }
            />
          }
        </div>
      </div>
    );
  }
}

AllocationGrid.propTypes = {
  onPageChange: PropTypes.func,
  fetchingAllocations: PropTypes.bool,
  showPagination: PropTypes.bool,
  backgroundColor: PropTypes.string,
  onAllocationSelect: PropTypes.func,
  allocationRules: PropTypes.arrayOf(RULE_PROP_TYPE).isRequired,
  pageState: PropTypes.object
};

AllocationGrid.defaultProps = {
  fetchingAllocations: false,
  onPageChange: () => null,
  showPagination: false,
  backgroundColor: '#fff'
};

export default AllocationGrid;



// WEBPACK FOOTER //
// ./src/shared/components/allocationGrid/AllocationGrid.js